import { lightErrorToast } from "../../Components/customToast";
import requestMethods from "../../helpers/request";
import { API_TYPE } from "../constants";

export const updateLivePing = () => async () => {
  try {
    await requestMethods.POST({
      endpoint: `v1/mobile/data/ping`,
      type: API_TYPE.EDGE_API,
    });
  } catch (error) {
    lightErrorToast(error.message);
  }
};
